/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_Heading_PrefixInputs */

const en_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let's ship your`)
};

const ar_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لنطلق`)
};

const bn_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চলুন, আপনার`)
};

const de_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir bringen Ihre`)
};

const es_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llevemos tu`)
};

const fr_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnons vie à votre`)
};

const pt_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vamos lançar sua`)
};

const zh_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让我们打造你的`)
};

const tr_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hadi başlatalım`)
};

const ru_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Давайте запустим ваш`)
};

const pl_cta_heading_prefix = /** @type {(inputs: Cta_Heading_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbudujmy Twoje`)
};

/**
* | output |
* | --- |
* | "Let's ship your" |
*
* @param {Cta_Heading_PrefixInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_heading_prefix = /** @type {((inputs?: Cta_Heading_PrefixInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_Heading_PrefixInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_heading_prefix(inputs)
	if (locale === "bn") return bn_cta_heading_prefix(inputs)
	if (locale === "de") return de_cta_heading_prefix(inputs)
	if (locale === "es") return es_cta_heading_prefix(inputs)
	if (locale === "fr") return fr_cta_heading_prefix(inputs)
	if (locale === "pt") return pt_cta_heading_prefix(inputs)
	if (locale === "zh") return zh_cta_heading_prefix(inputs)
	if (locale === "tr") return tr_cta_heading_prefix(inputs)
	if (locale === "ru") return ru_cta_heading_prefix(inputs)
	if (locale === "pl") return pl_cta_heading_prefix(inputs)
	return en_cta_heading_prefix(inputs)
});